import { doChangePhone } from "@/api/user";
import Vector from "@/assets/SVG/vector";
import Timer from "@/components/signin/timer";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import VerificationInput from "react-verification-input";

export default function CheckPhone({
  setShow,
  dataCheckCode,
  setDataCheckCode,
  changeCallback,
}) {
  const [code, setCode] = useState();

  useEffect(() => {
    if (code) setDataCheckCode({ ...dataCheckCode, code: Number(code) });
  }, [code]);

  return (
    <Box display="flex" alignItems="center" gap="20px">
      <Box display="grid" gap={"20px"}>
        <Typography fontSize="18px">{"تایید شماره تلفن همراه"}</Typography>
        <Typography color="var(--emr-disable)" fontSize="16px">
          {"جهت تایید شماره تلفن همراه، کد پیامک شده را وارد نمایید."}
        </Typography>
        <Box>
          <VerificationInput
            onChange={setCode}
            length={6}
            validChars="0-9"
            removeDefaultStyles
            classNames={{
              container: "container",
              character: "character",
              characterInactive: "character--inactive",
              characterSelected: "character--selected",
            }}
          />
          <Timer initialMinute={2} initialSeconds={0} />
        </Box>
        <Box
          mt="20px"
          display="flex"
          justifyContent="space-between"
          alignItems={"center"}
        >
          <button
            style={{
              border: "none",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",

              padding: "12px 0px",
              marginTop: "20px",
              borderRadius: "8px",
            }}
            onClick={() => setShow(false)}
          >
            <Box sx={{ transform: "rotate(180deg)", mt: "-4px" }}>
              <Vector color="#626262" />
            </Box>
            <Typography
              fontWeight={"bold"}
              fontSize="13px"
              color="#626262"
              mx="10px"
            >
              ویرایش شماره تلفن همراه
            </Typography>
          </button>
          <button
            style={{
              border: "none",
              width: "150px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "var(--emr-primary)",
              boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              padding: "12px 0px",
              marginTop: "20px",
              borderRadius: "8px",
            }}
            onClick={() => {
              doChangePhone(dataCheckCode)
                .then(() => {
                  setShow(false);
                  if (changeCallback) changeCallback();
                })
                .catch(() => {});
            }}
          >
            <Typography fontSize="16px" color="white" ml="10px">
              تایید
            </Typography>
          </button>
        </Box>
      </Box>
    </Box>
  );
}
